var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timerContaienr"},[_c('div',[_c('img',{staticClass:"clock",attrs:{"src":require("../assets/clock.png")}}),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.getCountDown))])])])}
var staticRenderFns = []

export { render, staticRenderFns }